// BackToTop.jsx - Enhanced version with scroll progress
import React, { useState, useEffect } from 'react';
//import './BackToTop.css';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const updateProgress = () => {
    const scrollTop = window.pageYOffset;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const progress = (scrollTop / docHeight) * 100;
    setScrollProgress(progress);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      toggleVisibility();
      updateProgress();
    });
    
    return () => {
      window.removeEventListener('scroll', () => {
        toggleVisibility();
        updateProgress();
      });
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button onClick={scrollToTop} className="back-to-top-progress">
          <svg className="progress-ring" width="50" height="50">
            <circle
              className="progress-ring__circle"
              stroke="currentColor"
              strokeWidth="3"
              fill="transparent"
              r="22"
              cx="25"
              cy="25"
              strokeDasharray={`${2 * Math.PI * 22}`}
              strokeDashoffset={`${2 * Math.PI * 22 * (1 - scrollProgress / 100)}`}
            />
          </svg>
          <svg 
            className="arrow-icon"
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2"
          >
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
        </button>
      )}
    </>
  );
};

export default BackToTop;